namespace Gamification.Gamification {
    export interface AssetEsperienzeRow {
        IdAssetEsperienza?: number;
        UserId?: number;
        TenantId?: number;
        IdDispositivo?: number;
        IdTipologiaEsperienza?: number;
        IdentifierAssetEsperienza?: string;
        Nome?: string;
        NomeFileAssetBundle?: string;
        PathFileAssetBundle?: string;
        UrlAssetBundle?: string;
        VersioneAssetBundle?: number;
        NomeFileCoverAssetBundle?: string;
        PathFileCoverAssetBundle?: string;
        UrlCoverAssetBundle?: string;
        NomeFileManifestAssetBundle?: string;
        PathFileManifestAssetBundle?: string;
        UrlManifestAssetBundle?: string;
        IsCloned?: boolean;
        IdAssetEsperienzaOriginal?: number;
        TemporaryNomeFileAssetBundle?: string;
        TemporaryPathFileAssetBundle?: string;
        TemporaryNomeFileCoverAssetBundle?: string;
        TemporaryPathFileCoverAssetBundle?: string;
        TemporaryNomeFileManifestAssetBundle?: string;
        TemporaryPathFileManifestAssetBundle?: string;
        IdDispositivoNome?: string;
        IdTipologiaEsperienzaNome?: string;
        NumeroClassi?: number;
    }

    export namespace AssetEsperienzeRow {
        export const idProperty = 'IdAssetEsperienza';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.AssetEsperienze';
        export const lookupKey = 'Gamification.AssetEsperienze';

        export function getLookup(): Q.Lookup<AssetEsperienzeRow> {
            return Q.getLookup<AssetEsperienzeRow>('Gamification.AssetEsperienze');
        }
        export const deletePermission = 'Gamification:Configurazione';
        export const insertPermission = 'Gamification:Configurazione';
        export const readPermission = 'Gamification:Configurazione';
        export const updatePermission = 'Gamification:Configurazione';

        export declare const enum Fields {
            IdAssetEsperienza = "IdAssetEsperienza",
            UserId = "UserId",
            TenantId = "TenantId",
            IdDispositivo = "IdDispositivo",
            IdTipologiaEsperienza = "IdTipologiaEsperienza",
            IdentifierAssetEsperienza = "IdentifierAssetEsperienza",
            Nome = "Nome",
            NomeFileAssetBundle = "NomeFileAssetBundle",
            PathFileAssetBundle = "PathFileAssetBundle",
            UrlAssetBundle = "UrlAssetBundle",
            VersioneAssetBundle = "VersioneAssetBundle",
            NomeFileCoverAssetBundle = "NomeFileCoverAssetBundle",
            PathFileCoverAssetBundle = "PathFileCoverAssetBundle",
            UrlCoverAssetBundle = "UrlCoverAssetBundle",
            NomeFileManifestAssetBundle = "NomeFileManifestAssetBundle",
            PathFileManifestAssetBundle = "PathFileManifestAssetBundle",
            UrlManifestAssetBundle = "UrlManifestAssetBundle",
            IsCloned = "IsCloned",
            IdAssetEsperienzaOriginal = "IdAssetEsperienzaOriginal",
            TemporaryNomeFileAssetBundle = "TemporaryNomeFileAssetBundle",
            TemporaryPathFileAssetBundle = "TemporaryPathFileAssetBundle",
            TemporaryNomeFileCoverAssetBundle = "TemporaryNomeFileCoverAssetBundle",
            TemporaryPathFileCoverAssetBundle = "TemporaryPathFileCoverAssetBundle",
            TemporaryNomeFileManifestAssetBundle = "TemporaryNomeFileManifestAssetBundle",
            TemporaryPathFileManifestAssetBundle = "TemporaryPathFileManifestAssetBundle",
            IdDispositivoNome = "IdDispositivoNome",
            IdTipologiaEsperienzaNome = "IdTipologiaEsperienzaNome",
            NumeroClassi = "NumeroClassi"
        }
    }
}
